"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMutatedStates = exports.removeAvatar = exports.uploadAvatar = exports.viewLog = exports.editStates = exports.editLanguage = exports.getQueryLogs = exports.getServices = exports.getServiceExperts = exports.getExperts = exports.getLocations = exports.getAreas = exports.getSingleExpert = exports.getAdminSingleExpert = exports.updateLicense = exports.updateEducation = exports.editLicense = exports.editEducation = exports.addDraftLicense = exports.addDraftEducation = exports.submit = exports.editExpert = exports.initCreateExpert = exports.initEditExpert = exports.getExpertsList = exports.setAdminActionType = exports.setMutatedStates = exports.resetMounted = exports.bindViewLog = exports.bindAvatar = exports.bindEditStates = exports.bindEditLanguage = exports.setQueryLogs = exports.setLocations = exports.servicesList = exports.setExperts = exports.setFilters = exports.categoriesList = exports.bindEditLicense = exports.updateEditableLicense = exports.addEmptyLicense = exports.updateEditableEducation = exports.bindEditEducation = exports.addEmptyEducation = exports.updateExpert = exports.initEdit = exports.edit = exports.expertsListError = exports.expertsList = exports.setExpert = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const set_1 = __importDefault(require("lodash/set"));
const pick_1 = __importDefault(require("lodash/pick"));
const uniqBy_1 = __importDefault(require("lodash/uniqBy"));
const uniq_1 = __importDefault(require("lodash/uniq"));
const last_1 = __importDefault(require("lodash/last"));
const api_1 = require("../../services/api");
const store_1 = __importDefault(require("../store"));
const preloaderSlice_1 = require("../slices/preloaderSlice");
const auth_1 = __importDefault(require("../../services/api/auth"));
const common_1 = require("../../utils/common");
const staticDataSlice_1 = require("./staticDataSlice");
const removeFileUrl = '/admin/experts/delete-avatar';
const uploadFileUrl = 'admin/experts/upload-avatar';
const draftEducation = {
    "raw": "",
    "school": "",
    "degree": "",
    "study": "",
    "startYear": "",
    "endYear": ""
};
const draftLicense = {
    "state": "",
    "license_id": "",
    "month": "",
    "year": "",
    "type": "license"
};
let submitting = false;
const editable = [
    "name",
    "company_name",
    "email",
    "website",
    "address",
    "bio",
    "phone",
    "blocks",
    "status",
    "mainService",
    "avatar"
];
const createable = [
    "type",
    "uid",
    "is_company"
];
const initialState = {
    adminActionType: '',
    expert: {
        address: {
            city: '',
            number: '',
            state: '',
            street: '',
            stateFullName: '',
            street_address: '',
            type: '',
            zip: '',
        },
        mainService: { name: '' },
        blocks: {
            occupation: null,
            social: {
                twitter: null,
                facebook: null,
                linkedin: null
            },
            education: [],
            certs: []
        },
        contactInfo: {
            email: null,
            phone: {
                fax: null,
                mobile: null,
                office: null
            },
            website: null,
            address: null
        },
        areas: [],
        languages: [],
        services: [],
        states: [],
        avatar: ''
    },
    list: [],
    count: 0,
    visibleCount: 50,
    editableExpert: null,
    editableEducation: { edu: null, index: null },
    editableLicense: { license: null, index: null },
    editableLanguage: { lang: {}, index: false },
    editableState: { state: {}, index: false },
    areas: [],
    services: [],
    mergeServices: [],
    mergeStates: [],
    areasSubCats: [],
    expertsList: [],
    locations: [],
    queryLogs: {},
    viewLog: null,
    expertsCount: 0,
    mounted: false,
    filter: {
        selectedFilters: [],
        q: '',
        selectedStates: [],
        offset: 0,
        limit: 25,
        action: 'directory'
    }
};
const mutateAdminExpert = expert => {
    expert.phone = JSON.parse(expert.phone);
    expert = mutateAdminAvatar(expert);
    return expert;
};
const mutateAdminAvatar = expert => {
    let newAvatar = "";
    if (expert.avatar) {
        if (expert.avatar.includes("http")) {
            newAvatar = expert.avatar;
        }
        else {
            newAvatar = `${window.AppearMe.appConfigs.url}/experts/file/${expert.avatar}?token=${localStorage.getItem("token")}`;
        }
        expert.avatar = newAvatar;
    }
    return expert;
};
const mutateExpert = expert => {
    var _a, _b;
    expert.phone = JSON.parse(expert.phone);
    expert.contactInfo = {
        email: expert.email,
        phone: expert.phone,
        website: (_a = expert.blocks.social) === null || _a === void 0 ? void 0 : _a.website,
        address: expert.address
    };
    let avatar = "";
    if (expert.avatar) {
        if (expert.avatar.includes("http")) {
            avatar = expert.avatar;
        }
        else {
            avatar = `${window.AppearMe.appConfigs.url}/experts/file/${expert.avatar}?token=${localStorage.getItem("token")}`;
        }
    }
    expert.avatar = avatar;
    ((_b = expert.blocks.social) === null || _b === void 0 ? void 0 : _b.website) && delete expert.blocks.social.website;
    return expert;
};
const deMutateExpert = expert => {
    const education = (expert.blocks.education || []).filter(v => !v.deleted);
    const certs = (expert.blocks.certs || []).filter(v => !v.deleted);
    const blocks = Object.assign(Object.assign({}, expert.blocks), { certs,
        education });
    expert.blocks = JSON.stringify(blocks);
    if (typeof expert.phone !== 'string') {
        expert.phone = JSON.stringify(expert.phone);
    }
    let mainService = expert.mainService;
    if (expert.avatar) {
        const trimmedAvatar = last_1.default(expert.avatar.split("?")[0].split('/'));
        expert.avatar = trimmedAvatar;
    }
    if (expert.address) {
        const keys = ["street_address", "city", "state", "zip"];
        expert.address = keys
            .map(key => expert.address[key])
            .filter(v => v).join(" ");
    }
    if (expert.areas) {
        expert.areas = {
            added: expert.areas.filter(a => a.new).map(v => v.id),
            deleted: expert.deletedAreas
        };
    }
    if (expert.services) {
        expert.services = {
            added: expert.services.filter(a => a.new).map(v => {
                return {
                    service_id: v.service_id || v.id,
                    sub_service_id: v.service_id ? v.id : null
                };
            }),
            deleted: expert.deletedServices
        };
    }
    if (expert.languages) {
        expert.languages = {
            added: expert.languages.filter(l => l.added),
            edited: expert.languages.filter(l => l.edited),
            deleted: expert.languages.filter(l => l.deleted)
        };
    }
    if (expert.states) {
        expert.states = {
            added: expert.states.filter(s => s.new).map(v => {
                return {
                    state_id: v.id
                };
            }),
            deleted: expert.deletedStates
        };
    }
    if (expert.mainService && !expert.mainService.id) {
        mainService = {
            id: expert.mainService.service_id
        };
    }
    return Object.assign(Object.assign({}, pick_1.default(expert, editable, !expert.createdAt ? createable : [])), { areas: expert.areas, services: expert.services, languages: expert.languages, states: expert.states, mainService });
};
const serializeLocation = states => {
    states = states.map(s => {
        s.parent_id = 53;
        return s;
    });
    return [
        {
            "id": 54,
            "name": "Multiple Locations",
            "subCategories": [],
            "singleCheckbox": true
        },
        {
            "id": 53,
            "name": "Nationwide",
            "subCategories": states
        }
    ];
};
const prepareServicesRequestData = data => {
    const services = store_1.default.getState().experts.services;
    const child = data.selectedFilters.filter(v => !v.isLang);
    let singleFilterAllSelected = false;
    const parent = uniq_1.default(data.selectedFilters.map(v => v.parent_id));
    if (parent.length === 1) {
        const service = child[0] ? services.find(s => s.id === child[0].parent_id) : false;
        if (service) {
            singleFilterAllSelected = child.length === service.subCategories.length;
        }
    }
    const selectedLanguages = data.selectedFilters.filter(v => v.isLang).map(v => v.id);
    return Object.assign(Object.assign({}, data), { selectedFilters: child.map(v => v.id), selectedFiltersParent: uniq_1.default(parent), selectedLanguages, selectedStates: data.selectedStates.map(i => i.id), singleFilterAllSelected });
};
const prepareExpertsRequestData = data => {
    const selectedFilters = uniq_1.default(data.selectedFilters.map(v => v.id));
    return Object.assign(Object.assign({}, data), { selectedFilters, selectedStates: data.selectedStates.map(i => i.id) });
};
const expertsSlice = toolkit_1.createSlice({
    name: 'experts',
    initialState: initialState,
    reducers: {
        setExpert: (state, action) => {
            state.expert = action.payload;
            return state;
        },
        expertsList: (state, action) => {
            state.list = (action.payload.experts || []).map(mutateExpert);
            state.count = action.payload.count || 0;
            return state;
        },
        updateExpert: (state, action) => {
            const expertIndex = state.list.findIndex(e => e.id === action.payload.id);
            if (expertIndex > -1) {
                state.list[expertIndex] = mutateExpert(action.payload);
            }
            return state;
        },
        initEdit: (state, action) => {
            state.editableExpert = action.payload;
            return state;
        },
        edit: (state, action) => {
            const { key, val } = action.payload;
            const value = typeof val === "string" ? val.trim() : val;
            set_1.default(state.editableExpert, key, value);
            return state;
        },
        addEmptyEducation: (state, action) => {
            const length = action.payload;
            if (!length) {
                state.editableExpert.blocks.education = [];
            }
            state.editableEducation = {
                edu: draftEducation,
                index: length
            };
            return state;
        },
        addEmptyLicense: (state, action) => {
            const length = action.payload;
            if (!length) {
                state.editableExpert.blocks.certs = [];
            }
            state.editableLicense = {
                license: draftLicense,
                index: length
            };
            return state;
        },
        bindEditEducation: (state, action) => {
            state.editableEducation = action.payload;
            return state;
        },
        bindEditLicense: (state, action) => {
            state.editableLicense = action.payload;
            return state;
        },
        updateEditableEducation: (state, action) => {
            const { key, val } = action.payload;
            const value = typeof val === "string" ? val.trim() : val;
            set_1.default(state.editableEducation.edu, key, value);
            return state;
        },
        updateEditableLicense: (state, action) => {
            const { key, val } = action.payload;
            const value = typeof val === "string" ? val.trim() : val;
            set_1.default(state.editableLicense.license, key, value);
            return state;
        },
        expertsListError: (state, action) => action.payload,
        categoriesList: (state, action) => {
            state.areas = action.payload.categories;
            state.areasSubCats = uniqBy_1.default(action.payload.categories.reduce((acc, val) => {
                acc = [].concat(acc, val.subCategories.filter(v => v.id && v.name));
                return acc;
            }, []), 'name');
            return state;
        },
        setLocations: (state, action) => {
            state.locations = action.payload;
            return state;
        },
        setQueryLogs: (state, action) => {
            state.queryLogs = action.payload;
            return state;
        },
        servicesList: (state, action) => {
            state.services = action.payload.services.slice(0);
            state.mergeServices = action.payload.services.reduce((acc, val) => {
                if (val.subCategories.length) {
                    acc.push(...val.subCategories);
                }
                else {
                    delete val.subCategories;
                    acc.push(val);
                }
                return acc;
            }, []);
            return state;
        },
        setFilters: (state, action) => {
            if (action.payload) {
                const type = action.payload.type;
                state.filter = action.payload;
                if (common_1.isMobileBrowser().check || common_1.ifMobile()) {
                    localStorage.setItem(`${type}_filter`, JSON.stringify(action.payload));
                }
            }
            return state;
        },
        setExperts: (state, action) => {
            state.expertsList = action.payload.experts.map(mutateExpert);
            state.expertsCount = action.payload.count;
            if (state.expertsList.length > 0) {
                state.mounted = true;
            }
            return state;
        },
        bindEditLanguage: (state, action) => {
            state.editableLanguage = action.payload;
            return state;
        },
        bindEditStates: (state, action) => {
            state.editableState = action.payload;
            return state;
        },
        bindAvatar: (state, action) => {
            state.editableExpert.avatar = action.payload;
            return state;
        },
        bindViewLog: (state, action) => {
            state.viewLog = action.payload;
            return state;
        },
        resetMounted: (state) => {
            state.mounted = false;
            return state;
        },
        setMutatedStates: (state, action) => {
            state.mergeStates = [
                {
                    'id': 53,
                    'name': 'Nationwide'
                },
                ...action.payload
            ];
            return state;
        },
        setAdminActionType: (state, action) => {
            state.adminActionType = action.payload;
            return state;
        }
    }
});
_a = expertsSlice.actions, exports.setExpert = _a.setExpert, exports.expertsList = _a.expertsList, exports.expertsListError = _a.expertsListError, exports.edit = _a.edit, exports.initEdit = _a.initEdit, exports.updateExpert = _a.updateExpert, exports.addEmptyEducation = _a.addEmptyEducation, exports.bindEditEducation = _a.bindEditEducation, exports.updateEditableEducation = _a.updateEditableEducation, exports.addEmptyLicense = _a.addEmptyLicense, exports.updateEditableLicense = _a.updateEditableLicense, exports.bindEditLicense = _a.bindEditLicense, exports.categoriesList = _a.categoriesList, exports.setFilters = _a.setFilters, exports.setExperts = _a.setExperts, exports.servicesList = _a.servicesList, exports.setLocations = _a.setLocations, exports.setQueryLogs = _a.setQueryLogs, exports.bindEditLanguage = _a.bindEditLanguage, exports.bindEditStates = _a.bindEditStates, exports.bindAvatar = _a.bindAvatar, exports.bindViewLog = _a.bindViewLog, exports.resetMounted = _a.resetMounted, exports.setMutatedStates = _a.setMutatedStates, exports.setAdminActionType = _a.setAdminActionType;
const getExpertsList = (props) => async (dispatch) => {
    try {
        /* if (props && !props.q) {
             dispatch(showLoader());
         }*/
        dispatch(exports.expertsList({ experts: [], count: 0 }));
        const payload = await api_1.Admin.expertsList(props);
        dispatch(exports.expertsList(payload));
        //dispatch(hideLoader())
    }
    catch (e) {
        dispatch(exports.expertsListError(e));
        //dispatch(hideLoader())
    }
};
exports.getExpertsList = getExpertsList;
const initEditExpert = (props) => dispatch => dispatch(exports.initEdit(props));
exports.initEditExpert = initEditExpert;
const initCreateExpert = (props) => dispatch => dispatch(exports.initEdit(props));
exports.initCreateExpert = initCreateExpert;
const editExpert = (props) => dispatch => dispatch(exports.edit(props));
exports.editExpert = editExpert;
const submit = () => async (dispatch) => {
    try {
        if (submitting)
            return null;
        submitting = true;
        const expert = Object.assign({}, store_1.default.getState().experts.editableExpert);
        const submittable = deMutateExpert(expert);
        if (expert.createdAt || expert.created_at) {
            await api_1.Admin.editExpert(submittable, expert.uid);
        }
        else {
            await api_1.Admin.createExpert(submittable);
            window.location.href = `#/admin-panel?tab=single-expert&uid=${submittable.uid}&action=edit`;
            dispatch(exports.setAdminActionType('edit'));
        }
        const expertNewData = await api_1.Experts.expert(expert.uid);
        dispatch(exports.initEdit(mutateAdminExpert(expertNewData)));
        submitting = false;
    }
    catch (e) {
        console.log(e);
        submitting = false;
        return e;
    }
};
exports.submit = submit;
const addDraftEducation = (length) => dispatch => dispatch(exports.addEmptyEducation(length));
exports.addDraftEducation = addDraftEducation;
const addDraftLicense = (length) => dispatch => dispatch(exports.addEmptyLicense(length));
exports.addDraftLicense = addDraftLicense;
const editEducation = (data) => dispatch => dispatch(exports.bindEditEducation(data));
exports.editEducation = editEducation;
const editLicense = (data) => dispatch => dispatch(exports.bindEditLicense(data));
exports.editLicense = editLicense;
const updateEducation = (data) => dispatch => dispatch(exports.updateEditableEducation(data));
exports.updateEducation = updateEducation;
const updateLicense = (data) => dispatch => dispatch(exports.updateEditableLicense(data));
exports.updateLicense = updateLicense;
const getAdminSingleExpert = (uid) => async (dispatch) => {
    const expert = await api_1.Experts.expert(uid);
    if (expert) {
        dispatch(exports.initEdit(mutateAdminExpert(expert)));
    }
};
exports.getAdminSingleExpert = getAdminSingleExpert;
const getSingleExpert = (uid) => async (dispatch) => {
    dispatch(preloaderSlice_1.showLoader());
    try {
        const expert = await api_1.Experts.expert(uid);
        dispatch(exports.setExpert(mutateExpert(expert)));
        dispatch(preloaderSlice_1.hideLoader());
    }
    catch (e) {
        dispatch(preloaderSlice_1.hideLoader());
    }
};
exports.getSingleExpert = getSingleExpert;
const getAreas = () => async (dispatch) => {
    const categories = await api_1.Experts.categories();
    dispatch(exports.categoriesList({ categories }));
};
exports.getAreas = getAreas;
const getLocations = () => async (dispatch) => {
    const locations = serializeLocation(await api_1.Static.statesOnly());
    dispatch(exports.setLocations(locations));
};
exports.getLocations = getLocations;
const getExperts = (data) => async (dispatch) => {
    dispatch(preloaderSlice_1.showAjaxLoader());
    dispatch(exports.setFilters(Object.assign(Object.assign({}, data), { type: "expert" })));
    try {
        const payload = await api_1.Experts.experts(prepareExpertsRequestData(data));
        dispatch(exports.setExperts(payload));
        dispatch(preloaderSlice_1.hideAjaxLoader());
    }
    catch (e) {
        return false;
    }
};
exports.getExperts = getExperts;
const getServiceExperts = (data) => async (dispatch) => {
    dispatch(preloaderSlice_1.showAjaxLoader());
    dispatch(exports.setFilters(Object.assign(Object.assign({}, data), { type: 'service' })));
    try {
        const payload = await api_1.Experts.serviceExperts(prepareServicesRequestData(data));
        dispatch(exports.setExperts(payload));
        dispatch(preloaderSlice_1.hideAjaxLoader());
    }
    catch (e) {
        return false;
    }
};
exports.getServiceExperts = getServiceExperts;
const getServices = () => async (dispatch) => {
    const services = await api_1.Experts.services();
    dispatch(exports.servicesList({ services }));
};
exports.getServices = getServices;
const getQueryLogs = (data) => async (dispatch) => {
    const queryLogs = await api_1.Admin.getQueryLogs(data);
    dispatch(exports.setQueryLogs(queryLogs));
};
exports.getQueryLogs = getQueryLogs;
const editLanguage = (data) => dispatch => dispatch(exports.bindEditLanguage(data));
exports.editLanguage = editLanguage;
const editStates = (data) => dispatch => dispatch(exports.bindEditStates(data));
exports.editStates = editStates;
const viewLog = (data) => dispatch => dispatch(exports.bindViewLog(data));
exports.viewLog = viewLog;
const uploadAvatar = (data) => async (dispatch) => {
    try {
        dispatch(preloaderSlice_1.showAjaxLoader());
        const payload = await auth_1.default.upload(uploadFileUrl, data.formData);
        const expert = Object.assign({}, store_1.default.getState().experts.editableExpert);
        const newData = Object.assign(expert, { avatar: payload.data.files[0].fd });
        if (data.created) {
            const submittable = deMutateExpert(newData);
            await api_1.Admin.editExpert(submittable, expert.uid);
            const updated = await api_1.Experts.expert(expert.uid);
            dispatch(exports.initEdit(mutateAdminAvatar(updated)));
        }
        else {
            dispatch(exports.initEdit(mutateAdminAvatar(newData)));
        }
        dispatch(preloaderSlice_1.hideAjaxLoader());
    }
    catch (e) {
        dispatch(preloaderSlice_1.hideAjaxLoader());
    }
};
exports.uploadAvatar = uploadAvatar;
const removeAvatar = (data) => async (dispatch) => {
    try {
        dispatch(preloaderSlice_1.showAjaxLoader());
        const expert = Object.assign({}, store_1.default.getState().experts.editableExpert);
        const newData = Object.assign(expert, { avatar: null });
        const submittable = deMutateExpert(newData);
        await api_1.Admin.editExpert(submittable, data.uid);
        dispatch(exports.bindAvatar(null));
        dispatch(mutateAdminAvatar(expert));
        auth_1.default.delete(removeFileUrl, { params: { userImage: data.avatar } });
        dispatch(preloaderSlice_1.hideAjaxLoader());
    }
    catch (e) {
        dispatch(preloaderSlice_1.hideAjaxLoader());
    }
};
exports.removeAvatar = removeAvatar;
const getMutatedStates = () => async (dispatch) => {
    try {
        const states = await api_1.Static.statesOnly();
        dispatch(staticDataSlice_1.setStates(states));
        return dispatch(exports.setMutatedStates(states));
    }
    catch (e) {
        return [];
    }
};
exports.getMutatedStates = getMutatedStates;
exports.default = expertsSlice.reducer;
